<template>
  <a-breadcrumb style="margin: 16px 0">
    <a-breadcrumb-item>贡献者</a-breadcrumb-item>
    <a-breadcrumb-item>开发者故事</a-breadcrumb-item>
  </a-breadcrumb>

  <div class="grid-container">
    <a-carousel class="carousel-area" style="grid-area: A" autoplay>
      <div v-for="(img, index) in images" :key="index" class="carousel-slide">
        <div class="carousel-image-blur" :style="{ backgroundImage: `url(${img})` }"></div>
        <img :src="img" alt="developer story" class="carousel-image" />
      </div>
    </a-carousel>

    <a-card style="grid-area: B" class="story-list-panel" :body-style="{ padding: '16px', height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }">
      <div class="story-list-title">
        <FireOutlined class="story-list-title-icon" />
        热门开发者故事
      </div>
      <div class="story-list-scroll">
        <a
          v-for="story in hotStories"
          :key="story.rank"
          :href="story.link"
          target="_blank"
          rel="noopener noreferrer"
          class="hot-story-item"
        >
          <div class="hot-story-top">
            <div class="hot-story-emoji">{{ story.emoji }}</div>
            <div class="hot-story-rank">#{{ story.rank }}</div>
          </div>
          <div class="hot-story-main-title">{{ story.title }}</div>
          <div class="hot-story-sub-title">{{ story.subtitle }}</div>
          <div class="hot-story-desc">{{ story.description }}</div>
          <div class="hot-story-author">作者：{{ story.author }}</div>
          <div class="hot-story-tags">
            <span v-for="tag in story.tags" :key="tag" class="hot-story-tag">{{ tag }}</span>
          </div>
        </a>
      </div>
    </a-card>

    <a-card v-for="card in sideCards" :key="card.area" :style="`grid-area: ${card.area}`" class="story-card" :class="card.area.toLowerCase()" :body-style="{ padding: '16px' }">
      <div class="story-card-bg" :style="{ backgroundImage: `url(${card.img})` }"></div>
      <div class="story-card-overlay"></div>
      <div class="story-card-content">
        <div class="story-card-title">{{ card.title }}</div>
        <div class="story-card-subtitle">{{ card.subtitle }}</div>
        <div class="story-card-tag">{{ card.tag }}</div>
      </div>
    </a-card>
  </div>
</template>

<script setup>
  import { FireOutlined } from '@ant-design/icons-vue';

  const images = [
    require('@/assets/developer-stories/1.jpg'),
    require('@/assets/developer-stories/2.jpg'),
    require('@/assets/developer-stories/3.jpg'),
    require('@/assets/developer-stories/4.jpg')
  ];

  const sideCards = [
    {
      area: 'C',
      img: require('@/assets/developer-stories/4.jpg'),
      title: '开发者大会盛况',
      subtitle: '2024 OpenHarmony开发者大会',
      tag: '1000+ 参会者'
    },
    {
      area: 'D',
      img: require('@/assets/developer-stories/1.jpg'),
      title: '代码马拉松',
      subtitle: '48 小时极限编程挑战',
      tag: '50+ 项目'
    },
    {
      area: 'E',
      img: require('@/assets/developer-stories/2.jpg'),
      title: '社区见面会',
      subtitle: '线下技术交流与分享',
      tag: '每月一次'
    }
  ];

  const hotStories = [
    {
      rank: 1,
      emoji: '🎯',
      title: '从校园到职场：我与开源鸿蒙的五年',
      subtitle: '五年磨一剑，从学生到技术专家',
      description: '记录在OpenHarmony社区中从新手到核心贡献者的成长历程',
      author: '贾佳豪',
      tags: ['校园', '职场', '成长'],
      link: 'https://mp.weixin.qq.com/s/4WbZwyu8kEY_0dNXSZI3-A'
    },
    {
      rank: 2,
      emoji: '🏭',
      title: '五年深耕，他用代码为工业互联筑底座',
      subtitle: '从传统工业到开源世界的跨越',
      description: '深入工业互联网领域，用OpenHarmony打造稳定可靠的底层系统',
      author: '吴富城',
      tags: ['工业互联', '底层系统', '5年+'],
      link: 'https://mp.weixin.qq.com/s/SA5xB_KNUBhS5AiMv2QRyg'
    },
    {
      rank: 3,
      emoji: '🌉',
      title: '徐敏：以代码为桥，在跨平台生态中笃行致远',
      subtitle: '跨平台技术专家的开源之路',
      description: '以代码为桥梁，在开源社区中构建跨平台生态体系',
      author: '徐敏',
      tags: ['跨平台', '核心贡献', '技术专家'],
      link: 'https://mp.weixin.qq.com/s/gERBPFY2D8tPDVhNlXl6-g'
    },
    {
      rank: 4,
      emoji: '⛏️',
      title: '从金融系统到矿山物联：开源鸿蒙开发者的跨界成长之路',
      subtitle: '跨界带来的技术创新',
      description: '将金融级安全经验应用于矿山物联网系统开发',
      author: '张宇昕',
      tags: ['跨界', '物联网', '安全'],
      link: 'https://mp.weixin.qq.com/s/qcotDPRzVifvK9F7rOd9tQ'
    },
    {
      rank: 5,
      emoji: '🎓',
      title: "00后开发者与开源鸿蒙的'双向奔赴'：因为热爱，所以前行",
      subtitle: '因为热爱，所以前行',
      description: '年轻开发者在OpenHarmony社区中的成长与贡献',
      author: '薛博璇',
      tags: ['00后', '开源新秀', '社区活跃'],
      link: 'https://mp.weixin.qq.com/s/O4VIz2-txXHqcwW0Q-qgZA'
    }
  ];
</script>

<style>
.grid-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: 200px 200px 200px;
  grid-template-areas:
    'A A A B'
    'A A A B'
    'C D E B';
  gap: 16px;
}

  .carousel-area {
    height: 400px;
    min-height: 400px;
    max-height: 400px;
    overflow: hidden;
    border-radius: 12px;
  }

  .carousel-slide {
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }

  .carousel-image-blur {
    position: absolute;
    inset: 0;
    background-size: cover;
    background-position: center;
    filter: blur(14px) brightness(0.9);
    transform: scale(1.12);
    z-index: 1;
  }

  .carousel-image {
    position: relative;
    z-index: 2;
    width: 100%;
    height: 400px;
    object-fit: contain;
  }

  .story-card {
    position: relative;
    color: #ffffff;
    border: none;
    border-radius: 12px;
    overflow: hidden;
    min-height: 200px;
    height: 100%;
    cursor: pointer;
    transition: transform 0.3s ease;
  }

  .story-card-bg {
    position: absolute;
    inset: 0;
    background-size: cover;
    background-position: center;
    transform: scale(1.03);
    z-index: 1;
    transition: transform 0.5s ease;
  }

  .story-card:hover {
    transform: scale(1.02);
  }

  .story-card:hover .story-card-bg {
    transform: scale(1.12);
  }

  .story-card-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.56);
    z-index: 2;
  }

  .story-card-content {
    position: absolute;
    left: 16px;
    bottom: 16px;
    z-index: 3;
    text-align: left;
  }

  .story-card-title {
    font-size: 15px;
    font-weight: 700;
    margin-bottom: 4px;
    line-height: 1.2;
  }

  .story-card-subtitle {
    font-size: 12px;
    opacity: 0.95;
    margin-bottom: 6px;
    line-height: 1.2;
  }

  .story-card-tag {
    font-size: 11px;
    color: #d3d9ff;
    background: rgba(16, 24, 40, 0.45);
    padding: 4px 10px;
    border-radius: 999px;
    display: inline-block;
    font-weight: 600;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.18);
  }

  .story-list-panel {
    height: 100%;
    border-radius: 12px;
    border: 1px solid #dbe3ef;
    overflow: hidden;
  }

  .story-list-title {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 700;
    color: #111827;
    margin-bottom: 10px;
    text-align: left;
    flex-shrink: 0;
  }

  .story-list-title-icon {
    margin-right: 8px;
    color: #2563eb;
    font-size: 18px;
  }

  .story-list-scroll {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 8px 6px 4px 2px;
  }

  .story-list-scroll::-webkit-scrollbar {
    width: 6px;
  }

  .story-list-scroll::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 999px;
  }

  .hot-story-item {
    display: block;
    text-decoration: none;
    border: 1px solid #d1d5db;
    border-radius: 14px;
    padding: 12px;
    margin-bottom: 12px;
    background: #f3f4f6;
    transition: all 0.25s ease;
    text-align: left;
  }

  .hot-story-item:first-child {
    margin-top: 2px;
  }

  .hot-story-item:last-child {
    margin-bottom: 0;
  }

  .hot-story-item:hover {
    border-color: #93c5fd;
    background: #eef4ff;
    box-shadow: 0 8px 18px rgba(59, 130, 246, 0.16);
  }

  .hot-story-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  .hot-story-emoji {
    font-size: 22px;
    line-height: 1;
  }

  .hot-story-rank {
    font-size: 30px;
    font-weight: 800;
    color: #2563eb;
    line-height: 1;
  }

  .hot-story-main-title {
    font-size: 16px;
    font-weight: 800;
    color: #111827;
    margin-bottom: 6px;
    line-height: 1.3;
  }

  .hot-story-sub-title {
    font-size: 14px;
    font-weight: 700;
    color: #2563eb;
    margin-bottom: 8px;
    line-height: 1.25;
  }

  .hot-story-desc {
    font-size: 12px;
    color: #4b5563;
    line-height: 1.45;
    margin-bottom: 8px;
  }

  .hot-story-author {
    font-size: 13px;
    font-weight: 700;
    color: #374151;
    margin-bottom: 7px;
  }

  .hot-story-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .hot-story-tag {
    font-size: 12px;
    color: #374151;
    background: #e5e7eb;
    padding: 4px 9px;
    border-radius: 999px;
    font-weight: 700;
    line-height: 1;
  }
</style>